// MARK://dhk8/storefront/components/SiteFooter
// Mini footer de plataforma para las páginas públicas (fila/reservas/consulta).
// Atribución discreta a NintaiGO con enlace al sitio.

export default function SiteFooter() {
  return (
    <footer className="sf-footer">
      <span>
        Hecho con{' '}
        <a className="sf-footer__link" href="https://nintaigo.com" target="_blank" rel="noreferrer">
          Nintai<span className="sf-footer__accent">GO</span>
        </a>
      </span>
    </footer>
  )
}
